import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { Button } from 'antd';
import { createSonarSelector } from '@lib/selectors';
import { DailySyncToggle } from './DailySyncToggle';
import { importsActions } from '@sonar-software/sonar-imports';
import { LastSyncSummary } from './LastSyncSummary';
import { PardotSync } from './PardotSync';
import { SonarCard } from '@ui/general';
import { useNavigate } from 'react-router-dom';
import { When } from 'react-if';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useAmplitude, useOnMount, useSonarSelector } from '@hooks';
const hasImportsSelector = createSonarSelector((state) => { var _a, _b, _c, _d, _e; return ((_e = (_d = (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.imports) === null || _a === void 0 ? void 0 : _a.latest) === null || _b === void 0 ? void 0 : _b.get) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0; });
export const SalesForceSummary = () => {
    const navigate = useNavigate();
    const logEvent = useAmplitude();
    const anyImports = useSonarSelector(hasImportsSelector);
    const requestGetImportsLatestAction = useAction(importsActions.requestGetImportsLatest);
    useOnMount(() => {
        requestGetImportsLatestAction({});
    });
    const handleClick = useCallback(() => {
        logEvent(AMPLITUDE_EVENT.VIEW_DIFFERENCES_CLICKED);
        navigate(FULL_ROUTES.TIMELINE);
    }, [logEvent, navigate]);
    const lastSyncSummaryText = `${COPY_SPECIFIC.LAST_SYNC_SUMMARY}`;
    return (React.createElement(SonarCard, { className: 'salesforce-summary', extra: React.createElement(When, { condition: anyImports },
            React.createElement(Button, { id: 'view-detailed-changes-button', onClick: handleClick }, COPY_SPECIFIC.VIEW_DETAILED_CHANGES)), title: React.createElement(React.Fragment, null,
            React.createElement("span", { className: 'h2' }, lastSyncSummaryText),
            React.createElement(PardotSync, null)) },
        React.createElement(LastSyncSummary, null),
        React.createElement(DailySyncToggle, null)));
};
